module.exports = __webpack_public_path__ + "static/media/U1-T2-3-1c.6fd7859c.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vo/U1-T2-3-1c.mp3
// module id = 575
// module chunks = 0